/**
 * Get User Report Items UseCase
 *
 * Fetches report items from Firestore filtered by parentId.
 * Used by the ReportUserSheet stepper to load items at each level.
 *
 * Pattern from Flutter: ReportRepository.getUserReportItems
 * Source: lib/data/repository/report_repository.dart
 */

import { reportService } from '@/domain/services/report/reportService';
import type { UserReportItemEntity } from '@/domain/entities/report/userReportItemEntity';

export class GetUserReportItemsUseCase {
  /**
   * Fetch report items by parentId
   *
   * @param parentId - null for root-level items, string ID for children
   * @returns Promise<UserReportItemEntity[]> - Ordered list of report items
   */
  async execute(parentId: string | null): Promise<UserReportItemEntity[]> {
    return reportService.getUserReportItems(parentId);
  }
}

export const getUserReportItemsUseCase = new GetUserReportItemsUseCase();
